import { InfoList } from "../types/infoLists";
import { Socials } from "../types/socials";

const SocialsList: InfoList = {
  header: "SOCIALS",
  list: [
    {
      label: "LinkedIn",
      link: `https://www.linkedin.com/company/erom-studio`,
    },
    {
      label: "Instagram",
      link: `https://www.instagram.com/erom.studio`,
    },
  ] as Socials[],
};

export default SocialsList;
